import React, { useEffect, useState } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plotly from 'plotly.js/lib/core';
import pie from 'plotly.js/lib/pie';
import { CircularProgress, Box } from '@mui/material';

Plotly.register([pie]);
const Plot = createPlotlyComponent(Plotly);

const LatePaymentsPieChart = ({ data, loading, error, chartTitle = 'Dummy Pie Chart', onLoaded, hoveredPeriod }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!data || data.length === 0) return;

    onLoaded?.();

    const filtered = hoveredPeriod ? data.filter((x) => x.paymentDatePeriod === hoveredPeriod) : data;

    const colors = ['#0E2756', '#B0C3E5'];

    const groupedData = filtered.reduce(
      (acc, { lateOnTime }) => {
        const label = lateOnTime?.toLowerCase();
        if (label === 'xx') acc['xx'] += 1;
        else if (label === 'yy') acc['yy'] += 1;
        return acc;
      },
      { xx: 0, yy: 0 }
    );

    const labels = Object.keys(groupedData);
    const values = Object.values(groupedData);

    const pieTrace = {
      labels,
      values,
      type: 'pie',
      name: chartTitle,
      marker: { colors },
      hoverinfo: 'label+percent+value',
      textinfo: 'label+percent',
    };

    setChartData([pieTrace]);
  }, [hoveredPeriod, data, onLoaded, chartTitle]);

  const layout = {
    title: {
      text: hoveredPeriod ? `${chartTitle} (${hoveredPeriod})` : chartTitle,
      font: { size: 18 },
    },
    margin: { l: 30, r: 30, t: 50, b: 30 },
    showlegend: true,
    autosize: true,
    legend: { orientation: 'h', x: 0.5, xanchor: 'center', y: -0.2 },
  };

  const config = {
    responsive: true,
    displaylogo: false,
    displayModeBar: 'hover',
    modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d'],
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) return <p>Error: {error}</p>;
  if (!chartData) return <p>No data available.</p>;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Plot data={chartData} layout={layout} config={config} style={{ width: '100%', height: '400px' }} />
    </div>
  );
};

// ✅ Wrapper with dummy data for testing
const GanntSummary = () => {
  const dummyData = [
    { paymentDatePeriod: 'Q1 2024', lateOnTime: 'xx' },
    { paymentDatePeriod: 'Q1 2024', lateOnTime: 'yy' },
    { paymentDatePeriod: 'Q2 2024', lateOnTime: 'yy' },
    { paymentDatePeriod: 'Q2 2024', lateOnTime: 'xx' },
    { paymentDatePeriod: 'Q2 2024', lateOnTime: 'xx' },
    { paymentDatePeriod: 'Q3 2024', lateOnTime: 'yy' },
  ];

  return (
    <Box sx={{ p: 4 }}>
      <LatePaymentsPieChart
        data={dummyData}
        loading={false}
        error={null}
        chartTitle="Dummy Pie Chart"
        hoveredPeriod=""
      />
    </Box>
  );
};

export default GanntSummary;
